import { render, staticRenderFns } from "./domain_check.vue?vue&type=template&id=627fe0d4&scoped=true&lang=pug&"
import script from "./domain_check.vue?vue&type=script&lang=js&"
export * from "./domain_check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627fe0d4",
  null
  
)

export default component.exports